import React from 'react';
import { Input as AntdInput } from 'antd';
import Label from '../label/Label';
import ErrorMessage from '../error-message/ErrorMessage';
import Skeleton from '../skeleton/Skeleton';
import styles from './Input.module.scss';
import cx from 'clsx';
import { getAutoComplete } from '../../utils/autofill-util';
const { TextArea, Search } = AntdInput;

const Input = ({
  containerClassName = '',
  value = '',
  placeholder = '',
  label = '',
  errorMsg = '',
  size = 'large',
  name = '',
  type = 'text',
  onChange = () => {},
  onBlur = () => {},
  onPressEnter = () => {},
  onClear = () => {},
  allowClear = false,
  autoFocus = false,
  required = false,
  labelClassName = '',
  disabled = false,
  inputRef,
  isPassword = false,
  rows = null,
  loading = false,
  loaderHeight = 42,
  variant = null,
  autoComplete,
  ...rest
}) => {
  const Component = rest?.inputType === 'search' ? Search : !!rows ? TextArea : AntdInput;
  const resolvedAutoComplete = autoComplete ?? getAutoComplete({ type, isPassword });

  return (
    <div className={cx(styles.inputContainer, containerClassName)}>
      {label && (
        <Label className={labelClassName} required={required}>
          {label}
        </Label>
      )}
      {loading ? (
        <Skeleton height={loaderHeight} />
      ) : isPassword ? (
        <AntdInput.Password
          value={value}
          placeholder={placeholder}
          size={size}
          name={name}
          type={type}
          status={errorMsg && 'error'}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          onPressEnter={onPressEnter}
          onClear={onClear}
          allowClear={allowClear}
          autoFocus={autoFocus}
          autoComplete={resolvedAutoComplete}
          ref={inputRef}
          {...rest}
        />
      ) : (
        <Component
          value={value}
          placeholder={placeholder}
          size={size}
          name={name}
          type={type}
          {...(variant && { variant })}
          status={errorMsg && 'error'}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          onPressEnter={onPressEnter}
          onClear={onClear}
          allowClear={allowClear}
          autoFocus={autoFocus}
          autoComplete={resolvedAutoComplete}
          ref={inputRef}
          {...(!!rows ? { rows: rows } : {})}
          {...rest}
        />
      )}
      {errorMsg && <ErrorMessage errorMessage={errorMsg} />}
    </div>
  );
};

export default Input;
